export default __webpack_public_path__ + "static/media/add-green.3c045852.svg";